import api from 'store/actions/api';

export const loadLocationForQuery = (query) =>
  function* () {
    return yield api.getGeoLocationSuggestions(query);
  };

export const loadPlaceDetails = (placeId) =>
  function* () {
    return yield api.getGeoLocationPlace(placeId);
  };
